module.exports = __webpack_public_path__ + "static/nks-logo-57303b8877bafa99329e17f65ae4d465.png";